import { DropdownButton, FlexBox, Icon } from '@dixa/lib-shared-habla';
import { CellContext, HeaderContext } from '@tanstack/react-table';
import { ArticleListItemResultFragment } from 'lib-knowledge-management-common/graphql';

import { ArticlesTableFeatures } from 'components/articlesTable/features';
import { NodeLockIconWithTooltip } from 'components/icons/nodeLockIcon/nodeLockIcon';

import { ArticlesTableDropdowns } from './articleTableDropdowns';

type ActionColumnHeaderContext = HeaderContext<
  ArticlesTableFeatures,
  ArticleListItemResultFragment,
  string
>;
type ActionColumnCellContext = CellContext<
  ArticlesTableFeatures,
  ArticleListItemResultFragment,
  string
>;
type GetActionColumnReturnType = {
  header: (info: ActionColumnHeaderContext) => JSX.Element;
  cell: (info: ActionColumnCellContext) => JSX.Element;
};

export function getArticlesViewActionColumn(): GetActionColumnReturnType {
  return {
    header: (info: ActionColumnHeaderContext) => (
      <span key={info.header.index} />
    ),
    cell: (info: ActionColumnCellContext) => {
      const collectionIdOfArticle =
        info.cell.row.original.parentCollections[0]?.id;
      const articleId = info.cell.getValue();
      const isSyncedWithElevio = info.cell.row.original.isSyncedWithElevio;
      return (
        <FlexBox gap="200" justifyContent="flex-end" alignItems="center">
          {isSyncedWithElevio && (
            <NodeLockIconWithTooltip label="Synced from Elevio" />
          )}
          <DropdownButton
            noArrow
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            buttonProps={{
              variant: 'tertiary',
              style: {
                padding: 'var(--dixa-size-spacer-200)',
              },
            }}
            dropdown={
              <ArticlesTableDropdowns
                articleId={articleId}
                collectionId={collectionIdOfArticle}
                isSyncedWithElevio={isSyncedWithElevio}
              />
            }
          >
            <Icon name="dots-h" />
          </DropdownButton>
        </FlexBox>
      );
    },
  };
}
